import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Card } from '@material-ui/core';

import MentorContact from './MentorContact';
import Mentees from './Mentees';
import './MentorMenteeCard.css';

const styles = {
  card: {
    minWidth: 280,
    height: 240,
  },
};

class MentorMenteeCard extends Component {
  state = {
    hasError: false
  };

  componentDidMount() {
    const { memberId, getMentorMenteeInfo, userSeason } = this.props;
    if(userSeason){
      getMentorMenteeInfo(memberId, userSeason);
    } else {
      getMentorMenteeInfo(memberId, null);
    }
  }

  componentDidUpdate(prevProps){
    const { memberId, userSeason, getMentorMenteeInfo } = this.props;
    if (userSeason !== prevProps.userSeason)  {
      getMentorMenteeInfo(memberId, userSeason);
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.error({ error, info });
  }

  render() {
    const {
      isMentor,
      isMentee,
      mentees,
      mentorInfo,
      umpireFetchStatus,
      umpires,
      getUmpsNextGame,
      mentorMenteeInfoStatus
    } = this.props;
    const { classes } = this.props;

  //  <div className={`mentor-mentee-card-container ${hiddenClass}`}>

    if (this.state.hasError) {
      return <div className="mentor-mentee-loading pt-skeleton" />;
    } else {
      return (
        <Card className={classes.card}>
          {isMentor ? (
            <Mentees
              mentees={mentees}
              umpireFetchStatus={umpireFetchStatus}
              umpires={umpires}
              getUmpsNextGame={getUmpsNextGame}
              mentorMenteeInfoStatus={mentorMenteeInfoStatus}
            />
          ) : isMentee ? (
            <MentorContact
              mentorInfo={mentorInfo}
              umpireFetchStatus={umpireFetchStatus}
              umpires={umpires}
              getUmpsNextGame={getUmpsNextGame}
            />
          ) : (
            <div className="mentor-mentee-loading pt-skeleton" />
          )}
        </Card>
      );
    }
  }
}

MentorMenteeCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MentorMenteeCard);



// WEBPACK FOOTER //
// ./src/components/MentorMenteeCard.js